import { getTrackById } from "../assets/asset_loaders/tracks";

/**
 * Converts a World track object to a string format
 * The ending location is the primary focus (where the race ends)
 * @param {Object} track - Track object with start and end properties
 * @returns {String} - Formatted string representation of the track
 */
export default function trackToString(track) {
    if (!track) return "";
    
    const startTrack = getTrackById(track.start);
    const endTrack = track.end ? getTrackById(track.end) : null;
    
    if (endTrack && startTrack.id !== endTrack.id) {
        // Highway race: shows the journey from start to end
        return `${startTrack.name} → ${endTrack.name}`;
    } else {
        // Full race at single track (end is null or same as start)
        return startTrack.name;
    }
}
